import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
const ribbonDims = { width: 89, height: 24 };
const CouponRibbon = loadable(
	() => import('./CouponRibbon'),
	{ fallback: <div style={ribbonDims} /> }
);
import {
	Wrapper,
	CouponHeaderContainerText,
	CouponHeaderContainer,
	LoadingWrapper,
} from './couponPickerStyles';
import Coupons from './Coupons';

const CouponPicker = ({
	loadingCoupons,
	selectedCouponCode,
	recentDeal,
	onCouponClick,
	code,
	visibleWordCount,
	coupons,
}) => {
	if ((!code && !recentDeal) || coupons.length === 0) return null;

	if (loadingCoupons) return (
		<LoadingWrapper>
			<CouponHeaderContainer>
				{"Searching for Deals...."}
			</CouponHeaderContainer>
		</LoadingWrapper>
	);

	return (
		<Wrapper className="pdp-coupon-picker">
			<CouponHeaderContainer>
				<CouponRibbon {...ribbonDims} />
				<CouponHeaderContainerText>
					Select from the following special offers to be applied to your order at checkout
				</CouponHeaderContainerText>
			</CouponHeaderContainer>
			{(coupons && coupons.length > 0) && (
				<Coupons
					onCouponClick={onCouponClick}
					selectedCouponCode={selectedCouponCode}
					coupons={coupons}
					visibleWordCount={visibleWordCount}
				/>
			)}
		</Wrapper>
	);
};

CouponPicker.propTypes = {
	loadingCoupons: PropTypes.bool,
	selectedCouponCode: PropTypes.string,
	discount: PropTypes.object,
	recentDeal: PropTypes.object,
	onCouponClick: PropTypes.func,
	code: PropTypes.string,
	sellerOptions: PropTypes.array,
	cratejoyOptions: PropTypes.array,
	visibleWordCount: PropTypes.number,
	coupons: PropTypes.array,
};

CouponPicker.defaultProps = {
	loadingCoupoons: false,
	visibleWordCount: 15,
	onCouponClick: () => null,
	coupons: [],
};

export default CouponPicker;
